import { useMutation } from '@tanstack/react-query';
import { supabase } from '../lib/supabaseClient';
import { useAuthStore } from '../store/useAuthStore';
import { useEffectiveTaskFields } from './useEffectiveTaskFields';
import { parseTaskTagDisplay, type TaskTagDisplay } from '../lib/tasks/taskTagDisplay';

/**
 * Affichage des étiquettes pour la personne connectée. Toujours « chips » quand
 * les étiquettes sont désactivées pour le cabinet : rien à afficher, ni bande ni pastille.
 */
export function useTaskTagDisplay(): TaskTagDisplay {
  const mode = useAuthStore((s) => parseTaskTagDisplay(s.collaborator?.task_tag_display));
  const { tags } = useEffectiveTaskFields();
  return tags ? mode : 'chips';
}

export function useUpdateTaskTagDisplay() {
  return useMutation({
    mutationFn: async (mode: TaskTagDisplay) => {
      // RPC SECURITY DEFINER : elle ne touche que la fiche de la personne connectée.
      const { error } = await supabase.rpc('update_my_task_tag_display', { p_mode: mode });
      if (error) throw new Error(`Impossible d’enregistrer l’affichage : ${error.message}`);
      return mode;
    },
    onSuccess: (mode) => {
      const { collaborator, setCollaborator } = useAuthStore.getState();
      if (collaborator) setCollaborator({ ...collaborator, task_tag_display: mode });
    },
  });
}
